/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import Value from "../../../components/Value";
import './style.scss';
import './style.css';
import moment from "moment-timezone";
import { Input } from "antd";


const formatDate = (dateString: string | null) => {
  if (!dateString) return "TBA";
  return moment(dateString).tz("Asia/Ho_Chi_Minh").format("MMMM Do YYYY");
};

const FundedProjects = () => {
  const { Search } = Input;
  const [data, setData] = useState<any>([]);

  const handleGetData = async (symbol: any) => {
    try {
      let res = [
        {
          "keyword": "zodax",
          "symbol": "ZODX",
          "currentPrice": 0.0013,
          "name": "Zodax",
          "logoUrl": "/images/new-home/p_1.png",
          "idoSupply": 100000000,
          "idoDate": "2025-09-28T09:00:00",
          "pricePer": 0.001,
          "exchanges": [
            {
              "name": "Coinstore",
              "logoUrl": "/images/new-home/c_1.png",
              "linkUrl": "https://www.coinstore.com/spot/ZODXUSDT?ts=1759226478180"
            }
          ]
        },
        {
          "keyword": "lendr-fi",
          "symbol": "RWAL",
          "symbolUSD": "USDC",
          "currentPrice": 0.047,
          "name": "Lendr.fi",
          "logoUrl": "/images/new-home/p_2.png",
          "idoSupply": 10000000,
          "idoDate": "2025-09-23T09:00:00",
          "pricePer": 0.03,
          "exchanges": [
            {
              "name": "Mexc",
              "logoUrl": "/images/new-home/c_2.png",
              "linkUrl": "https://www.mexc.com/exchange/RWAL_USDT"
            }
          ],
        },
      ];
      if (res) {
        setData(res);
      }
    } catch (error: any) {
      console.log('error: ', error);
    }
  }

  useEffect(() => {
    handleGetData("");
  }, []);

  const noData = (
    <>
      <img className="no-data" src="/images/empty.png" alt="" />
      <p>Currently there is no projects</p>
    </>
  );
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  return (
    <>
      <div className="main-setion fund">
        <div className="container">
          <div className="main-title">
            <h3 className="title new">Funded Projects</h3>
            <p className="desc new normal-text">We bring new technologies to our community</p>
          </div>
          <div className="search-project new">
            <Search
              placeholder="Search for project"
              // onSearch={onSearch}
              // onChange={onChange}
              style={{ width: 380 }}
            />
            <div className="icon-search">
              <img src="/images/imgido/search-normal.png" alt="" />
            </div>
          </div>
          <div className="fund-table-container">
            <table className="fund-table">
              <thead>
                <tr className="fund-table-header-tr">
                  <th className="fund-table-header-th">Project Name</th>
                  <th className="fund-table-header-th">Total Raise</th>
                  <th className="fund-table-header-th">Date</th>
                  <th className="fund-table-header-th">All Time High</th>
                  <th className="fund-table-header-th" style={{ textAlign: 'end' }}>Exchanges</th>
                </tr>
              </thead>
              <tbody>
                {(data?.length > 0) && data.map((project: any, index: any) => (
                  <tr key={index} className="fund-table-body-tr">
                    <td
                      // onClick={() => gotoIDODetail(project.network, project?.symbol, project?.isOldIDo, project?.idoTrust, project?.keyword)}
                      className="fund-table-body-td">
                      <div
                        className="td-name-container">
                        <img className="td-name-logo" alt='' src={project?.logoUrl} />
                        <div className="td-name">
                          <p className="name">{project?.name}</p>
                          <p className="symbol">{project?.symbol}</p>
                        </div>
                      </div>
                    </td>
                    <td className="fund-table-body-td">
                      <Value unit="$" decimals={0} value={project?.idoSupply * project?.pricePer} />
                      {/* <span>{project?.symbolUSD}</span> */}
                    </td>
                    <td className="fund-table-body-td">{formatDate(project?.idoDate)}</td>
                    <td className="fund-table-body-td">
                      <span
                        className={
                          Number(
                            (
                              (project.currentPrice / project.pricePer) *
                              100
                            ).toFixed(2)
                          ) < 100
                            ? "main-color-down"
                            : Number(
                              (
                                (project.currentPrice / project.pricePer) *
                                100
                              ).toFixed(2)
                            ) >= 100
                              ? "main-color-up"
                              : ""
                        }
                      >
                        {(
                          (project.currentPrice / project.pricePer) *
                          100
                        ).toFixed(2)}
                        %
                      </span>
                    </td>
                    <td className="fund-table-body-td exchange">
                      {project?.exchanges.length > 0 ?
                        project?.exchanges.map((item: any, index: any) => (
                          <a href={item.linkUrl} target="_blank"><img alt='' src={item.logoUrl} /></a>
                        ))
                        : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {
              !(data?.length > 0) &&
              <div>{noData}</div>
            }

          </div>
        </div>
      </div>
    </>
  );
};
export default FundedProjects;
